// /src/store.js (or wherever your store is configured)
import { configureStore } from "@reduxjs/toolkit";
import authReducer from './features/auth/authSlice';
import userReducer from './features/user/userSlice';
import devprojectReducer from './features/projects/devprojectSlice';
import desprojectReducer from './features/projects/desprojectSlice';
import certReducer from './features/certs/certSlice';
import profileReducer from './features/profile/profileSlice';
import blogReducer from './features/blog/blogSlice'; // Admin blog reducer
import publicBlogReducer from './features/blog/publicBlogSlice'; // Public blog reducer
import mediaReducer from './features/media/mediaSlice'; // Media reducer
import limiterReducer from './features/account/limiterSlice'; // Role limits reducer
import permissionReducer from './features/account/permissionSlice'; // Role limits reducer
import userManagementReducer from './features/account/userManagementSlice'; // User management reducer
import documentationPrivacyReducer from './features/account/documentationPrivacySlice'; // Documentation & Privacy reducer
import uiReducer from './features/ui/uiSlice'; // UI reducer
import visitorLimitsReducer from './features/visitor/visitorLimitsSlice';
import domainMigrationReducer from './features/migration/domainMigrationSlice';
import settingsReducer from './features/settings/settingsSlice'; // Settings reducer

export const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        devprojects: devprojectReducer,
        desprojects: desprojectReducer,
        certs: certReducer,
        profile: profileReducer,
        blogs: blogReducer, // Admin blog functionality
        publicBlogs: publicBlogReducer, // Public blog functionality
        media: mediaReducer, // Media management functionality
        limiter: limiterReducer, // Role limits functionality
        userManagement: userManagementReducer, // User management functionality
        documentationPrivacy: documentationPrivacyReducer, // Documentation & Privacy functionality
        ui: uiReducer, // UI state functionality
        visitorLimits: visitorLimitsReducer, // Visitor limits functionality
        domainMigration: domainMigrationReducer,
        permission: permissionReducer,
        settings: settingsReducer, // Settings functionality
    },
});